import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthStepEnum } from '../enums/auth.enum';

/** Способ входа, выбранный на шаге LOGIN и переносимый в CONFIRMATION. */
export type AuthChannel = 'phone' | 'email';

@Injectable({
  providedIn: 'root',
})
export class AuthStore {
  public authStep$: BehaviorSubject<AuthStepEnum> = new BehaviorSubject<AuthStepEnum>(
    AuthStepEnum.LOGIN
  );
  public phone$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  /** Текущий вход — по тестовому аккаунту (TOTP, 6-значный код вместо 4-значной SMS). */
  public isTestAccount$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public email$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public channel$: BehaviorSubject<AuthChannel> = new BehaviorSubject<AuthChannel>('phone');
}
